var map = {
	"./Group.svg": 5831,
	"./H_Judicial representation.svg": 4471,
	"./H_Legal support.svg": 1285,
	"./H_Secretariat services.svg": 9318,
	"./H_compliance services.svg": 1640,
	"./H_governance framework.svg": 1485,
	"./Hoved_bylaws.svg": 3621,
	"./Hoverd_acquisition_services.svg": 1907,
	"./Hoverd_companies.svg": 3880,
	"./Hoverd_contract.svg": 8177,
	"./Hoverd_legal_consultations.svg": 5557,
	"./Judicial representation.svg": 3662,
	"./Legal support.svg": 4276,
	"./Secretariat services.svg": 6305,
	"./acquisition services.svg": 8105,
	"./bylaws.svg": 5306,
	"./companies.svg": 2423,
	"./compliance services.svg": 8833,
	"./contract.svg": 1800,
	"./governance framework.svg": 6398,
	"./legal consultations.svg": 8579
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6966;